import { Component } from '@angular/core';

@Component({
  selector: 'app--back-office-dashboard',
  templateUrl: './dashboard-back-office.component.html',
  styleUrls: ['./dashboard-back-office.component.scss']
})
export class DashboardBackOfficeComponent {
}
